import PurchaseSummary from "./PurchaseSummary";
import Button from "../design/Button";
import { useState } from "react";
import { JService } from "../api-service/ApiService";
import { enqueueSnackbar } from "notistack";
import "./configurePlan.css";
import { getOrgURLParam } from "../../utility-functions";

const PurchaseSummaryFinal = ({ ...finalPurchaseData }) => {
  const {
    licenseCount,
    viewerCount,
    addonsList = [],
    addonCounts = {},
    currency,
    fullPlanName
  } = finalPurchaseData;

  const is_inr = currency === "₹";

  const [isLoading, setIsLoading] = useState(false);


  // --- API calls (pattern from Step4) ---


  const handleActivateSubscription = () => {
    const addons = addonsList
      .filter((addon) => (addonCounts[addon.id] || 0) > 0)
      .map((addon) => ({
        type: 'feature',
        feature_id: addon.id,
        quantity: addonCounts[addon.id],
      }));

    const payload = {
      plan: `${fullPlanName}`,
      quantity: licenseCount,
      keep_vn: false,
    };

    let licenses = [];

    if (viewerCount > 0) {
      licenses.push({
        type: "viewer",
        quantity: viewerCount
      });
    }
    if (addons.length > 0) {
      licenses.push(...addons);
    }

    if(licenses.length > 0) {
      payload.licenses = licenses;
    }

    JService.post(
      `/api/v1/subscriptions/activate-subscription/${getOrgURLParam()}`,
      JSON.stringify(payload),
    )
      .then((res) => {
        if (!res.success && !res?.checkout_url)
          throw new Error(res?.message || "Could not activate subscription");
        if (res?.checkout_url) {
          localStorage.setItem("account-upgraded-today", JSON.stringify(false));
          window.location.href = res.checkout_url;
        }
      })
      .catch((err) => {
        enqueueSnackbar(err?.message, { variant: "error" });
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const handlePurchase = async (e) => {
    try {
      e?.preventDefault();
      setIsLoading(true);

      handleActivateSubscription();
    } catch (err) {
      console.error("Error while activating subscription:", err);
      setIsLoading(false);
    }
  };


  return (
    <div className="review-and-pay">
      <PurchaseSummary
        {...finalPurchaseData}
        isInr={is_inr}
        FooterButton={({currency, total}) => (
          <Button
            styleOverride={{ width: "100%", marginTop: '20px' }}
            hierarchy="green"
            buttonText={`Pay ${currency}${total}`}
            onClick={handlePurchase}
            isLoading={isLoading}
          />
        )}
      />
    </div>

  );
};

export default PurchaseSummaryFinal;
